import { 
    apiBizGetTodoCount,
} from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_todo_count: 'todoList/set_todo_count',
    set_filter_query: 'todoList/set_filter_query',
}

// count state 必須是 Object
const state = {
    todoCount: {},
    filterQuery: {
        groupId: '',
        memberId: '',
        county: '',
        district: '',
    },
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    BIZ_TODO_LIST_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    BIZ_TODO_LIST_HOUSE_COUNT: (state) => {
        if(state.todoCount.house>=100){
            return '99+'
        }else{
            return state.todoCount.house
        }
    },
    BIZ_TODO_LIST_BOOKING_COUNT: (state) => {
        if(state.todoCount.booking>=100){
            return '99+'
        }else{
            return state.todoCount.booking
        }
    },
    BIZ_TODO_LIST_CONTRACT_COUNT: (state) => {
        if(state.todoCount.contract>=100){
            return '99+'
        }else{
            return state.todoCount.contract
        }
    },
    BIZ_TODO_LIST_TASK_COUNT: (state) => {
        if(state.todoCount.task>=100){
            return '99+'
        }else{
            return state.todoCount.task
        }
    },
    BIZ_TODO_LIST_HAS_COUNT: (state) => {
        let totalCount = state.todoCount.house+state.todoCount.booking+state.todoCount.contract+state.todoCount.task
        if(totalCount){
            return true
        }else{
            return false
        }
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizTodoCount ( {commit} ) {
        return new Promise((resolve, reject) => {
            apiBizGetTodoCount()
            .then(res => {
                console.log('res')
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_todo_count, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setBizTodoListFilter ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_todo_count](state, data){
        state.todoCount = data
    },
    [types.set_filter_query](state, query){
        state.filterQuery = query
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/personalHome/todoList.js